module.exports = __webpack_public_path__ + "static/media/natureFeedbackEffect.96b56954.mp3";